export default __webpack_public_path__ + "static/media/p2p-sg-girl.79377e25.webp";